import { openDB, type DBSchema } from 'idb';
import type { GeneratorConfig, StoredProject } from './types';

interface ScreenGridDatabase extends DBSchema {
  projects: {
    key: string;
    value: StoredProject;
    indexes: { 'by-updated': string };
  };
  appState: {
    key: string;
    value: GeneratorConfig;
  };
}

const databasePromise = openDB<ScreenGridDatabase>('screengrid-generator', 1, {
  upgrade(database) {
    const projects = database.createObjectStore('projects', { keyPath: 'id' });
    projects.createIndex('by-updated', 'updatedAt');
    database.createObjectStore('appState');
  },
});

export async function saveDraft(config: GeneratorConfig): Promise<void> {
  const database = await databasePromise;
  await database.put('appState', config, 'draft');
}

export async function loadDraft(): Promise<GeneratorConfig | undefined> {
  const database = await databasePromise;
  return database.get('appState', 'draft');
}

export async function listProjects(): Promise<StoredProject[]> {
  const database = await databasePromise;
  const projects = await database.getAllFromIndex('projects', 'by-updated');
  return projects.reverse();
}

export async function saveProject(project: StoredProject): Promise<void> {
  const database = await databasePromise;
  await database.put('projects', project);
}

export async function deleteProject(id: string): Promise<void> {
  const database = await databasePromise;
  await database.delete('projects', id);
}
